
  import {defineComponent} from "vue";
  import {mapState} from "vuex";

  export default defineComponent({
    name: 'product-info-component',
    computed: {
      ...mapState({
        product: (state: any) => state.ProductStore.product,
      })
    },
  });
